module.exports = __webpack_public_path__ + "static/media/prescription-bottle-alt.33041a46.svg";